<template>
    <div :id="this.$route.name">
        <card back add>
            <template v-slot:header>
                <h4 class="d-inline">لـیست پرسنل</h4>
                <hr />
            </template>
            <template v-slot:content>
                    <div class="row">
                    </div>
                    <BnpGrid v-if="$store.state.renderComponentGrid"  :propsColumn="Column" :propsRows="rows" :action="true" :hasRowNum="true" :Sortable="true" >
                        <template slot="action-slot" slot-scope="props">
                            <button class="btn-xs btn-success" @click="GetLegalRuling(props.props)">حکم حقوقی</button>
                            <button class="btn-xs btn-success mr-2" @click="GetPersonelFish(props.props)">حقوق پرداختنی</button>
                            <button class="btn-xs btn-success mr-2" @click="Getattachments(props.props)"> پیوست ها</button>
                            <a href="javascript:;" title="حذف آیتم" class="mr-2 badge" @click="OnDelete(props.props)">
                                <h6><span class="fas fa-trash-alt text-secondary hover-danger"></span></h6>
                            </a>
                            <a href="javascript:;" title="اصلاح آیتم" class="mr-2 badge" @click="OnEditNew(props.props)">
                                <h6><span class="fas fa-marker text-secondary hover-warning"></span></h6>
                            </a>
                        </template>
                    </BnpGrid>
            </template>
        </card>
    </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'

export default {
  components: { Card ,BnpGrid},
    data(){
        return{
            rows:[],
            Column:[
                {
                name: 'Id',
                label: 'Id',
                visibility: false,
                },
                {
                name: 'PersonnelStatus',
                label: 'وضعیت',
                visibility: true,
                },
                {
                name: 'PersonnelCode',
                label: 'کدپرسنلی',
                visibility: true,
                },
                {
                name: 'NamFam',
                label: 'مشخصات',
                visibility: true,
                },
                {
                name: 'NationalCode',
                label: 'کدملی',
                visibility: true,
                },
                {
                name: 'WorkShopName',
                label: 'نام کارگاه',
                visibility: true,
                },

            ],
            Sweet: ['حذف اطلاعات', 'آیا از حذف این اطلاعات اطمینان دارید ؟', 'warning', false],
            DataAxiosDelete: {
                ArryfildValue: '',
                Method: 'Delete',
                Action: this.$route.name,
                Token: this.$session.get('Token'),
            },
        }        
    },
    methods:{
            GetData(){
            var DataAxois={
                ArryfildValue:{},Method: 'Get',Action: 'Personnel',Token: this.$session.get('Token'),
            }
            this.$PostData(DataAxois).then((data) => {
                if(data!=null){
                    if(data.IsSuccess==true){
                        // console.log(data);
                        for (let index = 0; index < data.Data.length; index++) {
                            const element =  data.Data[index];
                            this.rows.push(element)
                        }
                    }
                }
          }).finally(() => {
                this.$store.state.renderComponentGrid = false
                this.$nextTick(() => {
                this.$store.state.renderComponentGrid = true
                })
            });
        },
        OnEditNew(row){
            this.$router.push({ name: 'Detail' + this.$route.name, params: { Status: 'Edit', DataRow: row } })
            this.$store.state.renderComponent = false
            this.$nextTick(() => {
                this.$store.state.renderComponent = true
            })
        },
        OnDelete(data){
            this.$store.state.OldDataForLog = JSON.stringify(data)
            this.DataAxiosDelete.ArryfildValue = { id: data.Id }
            this.$DeleteDatapropmise(this.DataAxiosDelete, this.Sweet).then((result) => {
                if (result == true) {
                this.$store.state.renderComponentGrid = false
                var temparrayNum = this.rows.indexOf(this.rows.filter((x) => x.Id == data.Id)[0])
                this.rows.splice(temparrayNum, 1)
                this.$nextTick(() => {
                    this.$store.state.renderComponentGrid = true
                })
                }else{
                    console.log('Cancel');
                }
            })
        },
        GetLegalRuling(data){
            // console.log(data);
            this.$router.push({ name: 'LegalRuling' , params: {DataRow: data} })
        },
        GetPersonelFish(data){
            // console.log(data);
            this.$router.push({ name: 'PersonelFish' , params: {DataRow: data},query:{PersonelId:data.Id} })
        },
        Getattachments(data){
            this.$router.push({ name: 'PersonelAttachments' , params: {DataRow: data} })
        }
        },
        mounted(){
            this.GetData()
        }
}
</script>
<style scoped>

</style>